import ethereum from './ethereum';

class RpcEngine {
    constructor(engines) {
        this.engines = engines;
    }

    filter = async (payload) => {
        const engine = this.getEngine(payload);
        return engine.filter(payload);
    }

    router = async (payload, state, setState) => {
        const engine = this.getEngine(payload);
        return engine.router(payload, state, setState);
    }

    render = async (payload) => {
        const engine = this.getEngine(payload);
        return engine.render(payload);
    }

    signer(payload, state, setState) {
        const engine = this.getEngine(payload);
        return engine.signer(payload, state, setState);
    }

    getEngine = async (payload) => {
        const match = this.engines.filter(engine => engine.filter(payload));
        if(!match || !match.length) {
            throw new Error(`No RPC engine foundto handle payload with method ${payload.method}`);
        }
        return match[0];
    }

}

export function getRpcEngine() {
    return new RpcEngine([ethereum]);
}